<template>
	<v-date-picker
		:value="value"
		:locale="locale"
		:max="max"
		:min="min"
		:no-title="noTitle"
		:range="range"
		:scrollable="scrollable"
		v-bind="$attrs"
		v-on="unhandled_events"
		@input="on_input"
	>
		<slot></slot>
		<template v-if="$scopedSlots.day" v-slot:day="dayProps">
			<slot name="day" v-bind="dayProps"></slot>
		</template>
	</v-date-picker>
</template>

<script>
export default {
	name: 'KDatePicker',
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value: {
			type: [String, Array],
			default: undefined
		},
		locale: {
			type: String,
			default: undefined
		},
		max: {
			type: String,
			default: undefined
		},
		min: {
			type: String,
			default: undefined
		},
		noTitle: {
			type: Boolean,
			default: false
		},
		range: {
			type: Boolean,
			default: false
		},
		scrollable: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		unhandled_events() {
			const { input, ...listeners } = this.$listeners;
			return listeners;
		}
	},
	methods: {
		on_input(value) {
			this.$emit('input', value);
		}
	}
};
</script>
